import { Navigate, useLocation } from "react-router-dom";

const OLD_BASE = "/people/membership-services/committees";
const NEW_BASE = "/people/membership-services/legacy-committees";

/**
 * Temporary compatibility redirect for the pre-rename committee URLs.
 *
 * The committee pages moved from `committees` to `legacy-committees`. Saved
 * links and in-flight sessions on the old paths would otherwise hit the 404
 * page, so we forward them (preserving search params and hash) until the
 * Rails-backed replacement routes land. Remove this folder once those ship.
 */
export default function LegacyCommitteesRedirect() {
  const location = useLocation();

  return (
    <Navigate
      to={{
        pathname: location.pathname.replace(OLD_BASE, NEW_BASE),
        search: location.search,
        hash: location.hash
      }}
      replace
    />
  );
}
